import appContext from '../bootstrap';

export const trackMetric = (...args) => appContext.trackMetric(...args);
